module.exports = __webpack_public_path__ + "static/media/215-Hochheben-ohne-Info_ID_2.a3dea124.mp3";